import { getCookie, setCookie } from 'cookies-next/client'

import { COOKIE_RECOMMENDATION_SESSION_ID_NAME } from './cookieNames'
import { cookiesIsUserConsentForAnalyticsGranted } from './cookiesIsUserConsentForAnalyticsGranted'

// one year in seconds
const RECOMMENDATION_SESSION_ID_COOKIE_MAX_AGE = 31_536_000

const recommendationSetSessionIdCookie = ({
  isAnalyticsConsentGranted,
  uuid,
}: {
  isAnalyticsConsentGranted: boolean
  uuid: string
}): void => {
  setCookie(COOKIE_RECOMMENDATION_SESSION_ID_NAME, uuid, {
    ...(isAnalyticsConsentGranted && {
      maxAge: RECOMMENDATION_SESSION_ID_COOKIE_MAX_AGE,
    }),
    path: '/',
    secure: true,
  })
}

const recommendationGetSessionIdCookie = (): string | undefined => {
  return getCookie(COOKIE_RECOMMENDATION_SESSION_ID_NAME)
}

export const cookiesGetOrGenerateRecommendationSessionId = (): string => {
  const recommendationSessionId = recommendationGetSessionIdCookie()
  const isAnalyticsConsentGranted = cookiesIsUserConsentForAnalyticsGranted()

  if (recommendationSessionId) {
    recommendationSetSessionIdCookie({
      isAnalyticsConsentGranted,
      uuid: recommendationSessionId,
    })

    return recommendationSessionId
  }

  const uuid = crypto.randomUUID()

  recommendationSetSessionIdCookie({
    isAnalyticsConsentGranted,
    uuid,
  })

  return uuid
}
